module.exports = __webpack_public_path__ + "static/media/completed_status_icon.e6829ddd.svg";